export const environment = {
  keycloakConfig: {
    url: 'https://ekmetijstvo.gov.si/auth',
    realm: 'arsktrp',
    clientId: 'evt',
  },
  production: true,
};
